import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import AlLeasingPricingUpdate from '../AlLeasingPricingUpdate'
import AlLeasePricingCopy from '../AlLeasePricingCopy'

type Props = {
    id: number,
}

const AlLeasePricingOverview = ({
    id,
}: Props) => {
    const {
        AlLeasePricing: AlLeasePricingRoutes,
    } = usePricingRoutes()

    return useSkyNetRoutes({
        routes: [
            {
                path: CommonRoutes.Slash,
                element: <AlLeasingPricingUpdate id={id} />,
            },
            {
                path: AlLeasePricingRoutes.Copy.stringParams,
                element: <AlLeasePricingCopy id={id} />,
            },
        ],
    })
}

export default AlLeasePricingOverview
